module.exports = __webpack_public_path__ + "a557bfb0f2358003d871733797df8e03.png";